// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__2viHq","title":"AfterImages45_title__vKqCG","images":"AfterImages45_images__8Wv7T"};